import { atom } from 'jotai';

/**
 * Progress for LandXML layers being fetched and parsed by `LandXML.tsx`.
 *
 * A civil DTM export routinely runs to 60–200 MB, so the gap between ticking a
 * layer on and seeing geometry is seconds to tens of seconds — long enough that
 * a silent viewer is indistinguishable from a broken one. (It was: a project of
 * eleven 100 MB+ surfaces was reported as "LandXML doesn't render" purely
 * because nothing on screen said the download was still running.)
 *
 * `fetching` while bytes are on the wire, `decoding` for the extract/parse pass
 * that follows, `failed` when the layer will never appear — mapped onto the
 * phases `LoadingBadge` already knows how to draw.
 */
export type LandxmlLoadingPhase = 'fetching' | 'decoding' | 'failed';

export interface LandxmlLoadingEntry {
  layerId: string;
  layerName: string;
  phase: LandxmlLoadingPhase;
  /** 0..1 transfer progress; only known when the response carried a Content-Length. */
  progress?: number;
  loadedBytes?: number;
  totalBytes?: number;
  /** Reason shown for the `failed` phase. */
  error?: string;
}

export const landxmlLoadingAtom = atom<Record<string, LandxmlLoadingEntry>>({});
